import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Sidebar = styled.section`
    background-color: var(--color-white);
    position: fixed;
    height: 100vh;
    overflow-y: auto;
    transition: all ease 0.2s;
    z-index: 2;
    max-width: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 20px;
    &.open { min-width: 180px; }
    &.closed {
        max-width: 80px;
        padding: 0 5px;
    }
    & a {
        text-decoration: none;
    }
    /* @media (max-width: 1140px) { */
        height: 100%;
        position: fixed;
        z-index: 5;
        &.menu-closed {
            transform: translateX(-100%);
        }
        &.menu-open {
            transform: translateX(0);
        }
    /* } */
`
export const Menu = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`
export const SidebarBrand = styled.div`
    transition: all ease 0.2s;
    display:flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    padding: 3rem 0 2.5rem 0;

    & .icone { width: 50px; }
    &.open img.logo {
        width: 145px;
    }
    &.open img.logo-mini {
        display: none;
    }
    &.closed img.logo {
        display: none;
    }
    &.closed img.logo-mini {
        display: none;
    }
    &.open p {
        color: var(--color-yellow);
        font-size: 28px;
        padding-left: 12px;
        font-weight: 600;
    }
    &.closed p {
        display: none;
    }

    &.closed a {
        display: table-cell;;
        justify-content: center;
    }
`
export const User = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px;
    margin: 0 auto 30px auto;
    transition: all ease 0.2s;
    border-radius: 15px;
    &:hover {
        // background-color: var(--color-sidebar-hover);
        cursor: pointer;
    }
    & img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-bottom: 24px;
    }
    & img.closed {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-bottom: 0;
    }
    & div.closed {
        display: none;
    }
`
export const Name = styled.p`
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    color: var(--color-green);
`
export const Email = styled.p`
    font-size: 12px;
    color: var(--color-green);
    text-align: center;
`
